<template>
  <div class="resources-view-card card" v-if="resource !== null">
    <div class="card-body">
      <div
        class="card-title resources-view-card__title"
        style="cursor: pointer"
        @click="goToDetailPage()"
      >
        {{ this.title }}
        <div class="heading-line-red-1"></div>
      </div>

      <div
        class="resources-view-card__video_box btn-link"
        @click="goToDetailPage()"
      >
        <div v-if="resource.content_type === 'video'" class="embed-responsive">
          <iframe-video
            :thumbnail_mode="true"
            :src="resource.content"
          ></iframe-video>
        </div>
        <img
          v-else
          :src="resource.content"
          alt=""
          class="resources-view-card__img img-fluid"
        />
      </div>

      <div class="resources-view-card__desc">
        {{ this.desc }}
      </div>
      <div class="d-flex mt-3">
        <div class="resources-view-card__date">
          {{ this.date }}
        </div>
        <div class="resources-view-card__watch_now">
          <button
            type="button"
            class="btn btn-link p-0"
            @click="goToDetailPage()"
          >
            {{ ctaText }}
            <i class="fa fa-chevron-right pl-1"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import moment from "moment"

export default {
  props: ["resource"],

  computed: {
    title() {
      return this.resource.title
    },
    desc() {
      return this.resource.short_description
    },
    date() {
      return moment(this.resource.created_at).format("DD MMM, YYYY")
    },
    ctaText() {
      return this.resource.content_type === 'video' ? 'Watch Now' : 'Read Now'
    }
  },

  methods: {
    goToDetailPage() {
      location.href = "/resources/" + this.resource.id
    },
  },

  mounted() { },
};
</script>

<style lang="scss" scoped>
.resources-view-card {
  position: relative;
  border: 1px solid #d5d5d5;
  border-radius: 8px;
  background-color: #ffffff;
  padding: 0;
  text-align: left;

  &__video_box {
    margin-bottom: 28px;
  }

  &__img {
    width: 100%;
    height: 136px;
    margin-bottom: 10px;
  }

  &__video {
    width: 100%;
    height: 136px;
    cursor: auto;

    * {
      cursor: crosshair;
    }
  }

  &__title {
    color: #303030;
    font-family: Lato;
    font-size: 22px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 36px;
  }

  .heading-line-red-1 {
    display: block;
    width: 60px;
    height: 3px;
    background-color: #ff375e;
    margin-bottom: 20px;
    margin-top: 5px;
  }

  &__desc {
    color: #606064;
    font-family: "Open Sans";
    font-size: 14px;
    letter-spacing: 0;
    line-height: 22px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -webkit-line-clamp: 3;
    text-overflow: ellipsis;
  }

  &__date {
    width: 50%;
    color: #606064;
    font-family: "Open Sans";
    font-weight: 500;
    font-size: 12px;
    line-height: 17px;
    text-align: left;
    margin: auto;
  }

  &__watch_now {
    width: 50%;
    font-size: 14px;
    line-height: 22px;
    text-align: right;
    font-weight: bold;
    color: #0db4e6;

    button {
      padding: 0px !important;
      text-decoration: none !important;
    }
  }

  .btn-link {
    color: #0db4e6;
    font-family: "Open Sans";
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 22px;
    text-align: center;
    cursor: pointer;
  }
}
</style>
